import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { motion, type HTMLMotionProps } from 'motion/react';

interface ApertavelProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  className?: string;
}

// Botão/cartão tocável: encolhe para 0.97 no toque e volta com mola
// (stiffness 500, damping 30). Não muda estilo nem comportamento — só o toque.
export default function Apertavel({
  className = '',
  children,
  disabled,
  ...rest
}: ApertavelProps) {
  return (
    <motion.button
      type="button"
      disabled={disabled}
      whileTap={disabled ? undefined : { scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      className={className}
      {...(rest as unknown as HTMLMotionProps<'button'>)}
    >
      {children}
    </motion.button>
  );
}